<template>
  <div class="p-3 bg-white mt-3">
    <h3 class="my-4 flex items-center justify-between">
      Wallets
      <button
        v-if="showAddWallet"
        @click="showActivateWallet = true"
        class="px-3 py-2 bg-primary-yellow rounded-md shadow-md"
      >
        Activate Wallet
      </button>
    </h3>

    <div
      class="grid-cols-5 grid px-2 border-b-2 border-gray-200 mb-1 pb-2 opacity-50"
    >
      <div class="">Account Name</div>
      <div>Wallet ID #</div>
      <div>Unsettled Balance (NGN)</div>
      <div>Available Balance (NGN)</div>
    </div>
    <div class="grid-cols-5 grid shadow-md my-2 px-2 py-3 rounded">
      <div>
        {{
          `${userWallet.user ? userWallet.user.firstname : ""} ${
            userWallet.user ? userWallet.user.lastname : ""
          }` || ""
        }}
      </div>
      <div>15426532659</div>
      <div>₦ 0.00</div>
      <div>
        ₦
        {{
          userWallet.balance ? amountFomatter(userWallet.balance / 100) : "0"
        }}.00
      </div>
      <div class="flex justify-end pr-2">
        <div
          class="relative outline-none"
          contenteditable="true"
          @blur="selectedRowId = false"
        >
          <span
            @click="selectedRowId = true"
            class="inline-block cursor-pointer"
            ><vertical-ellipsis
          /></span>
          <div class="actions" v-if="selectedRowId">
            <div>
              <p
                contenteditable="false"
                class="py-1 cursor-pointer"
                @click="$router.push('/settings/wallet-details')"
              >
                View
              </p>
              <p
                contenteditable="false"
                class="py-2 cursor-pointer"
                @click="showPaymentModal = true"
              >
                Fund Wallet
              </p>
              <p
                contenteditable="false"
                class="py-2 cursor-pointer"
                @click="isActive ? (showDeactivatewallet = true) : activateWalleFunct()"
              >
              {{ isActive ? "Deactivate" : 'Activate' }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <PaymentModal
      @close-modal="showPaymentModal = false"
      :show-modal="showPaymentModal"
      :paystackkey="paystackkey"
      @refresh="refresh"
      @onCardPayment="onCardPayment"
    />

    <ActivateWallet
    @closeModal="showActivateWallet = false"
    :show-modal="showActivateWallet"
    />

    <DeactivateWallet
      @closeModal="showDeactivatewallet = false"
      :show-modal="showDeactivatewallet"
      @reset="refresh"
    />

    <!-- <AddCardModal
      :showModal="showPaymentModal"
      @closeModal="showPaymentModal = false"
    /> -->
  </div>
</template>

<script>
import PaymentModal from "@/components/Ondemand/Payments/modals/PaymentModal.vue";
import DeactivateWallet from "./Modal/DeactivateWallet.vue";
// import AddCardModal from "@/components/Ondemand/Payments/modals/AddCardModal.vue";
import ActivateWallet from "./Modal/ActivateWalletNew.vue"

export default {
  components: { DeactivateWallet, PaymentModal, ActivateWallet },
  data() {
    return {
      selectedRowId: false,
      showPaymentModal: false,
      userWallet: {},
      showDeactivatewallet: false,
      showAddWallet: false,
      showActivateWallet: false,
      activateWallet: false,
      isActive: true
    };
  },
  mounted() {
    this.getUserWalletDetails();
  },
  methods: {
    async activateWalleFunct() {
      try {
        await this.$_activateWallet();
        this.getUserWalletDetails();
      } catch (error) {
        //
      }
    },
    refresh(){
       this.getUserWalletDetails()
    },
    async getUserWalletDetails() {
      this.userWallet = {}
      try {
        const response = await this.$_getUserWallet(
          localStorage.getItem("userId")
        );
        this.userWallet = response.data.userWallet;
        this.isActive = true
      } catch (error) {
        this.handleError(error);
        const status = { error }.error.request.status;
        if (status === 404) {
          this.showAddWallet = true;
        } else if ( status === 409){
            this.isActive = false
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.actions {
  @apply w-auto absolute right-0 bg-white shadow-md z-10 py-3 px-2;
  min-width: 200px;
}
.actions div p {
  @apply flex w-full py-2 px-2 items-center;
}
</style>
